import * as mock from "./mock";
import { create } from "../UtilsOld";

const Service = {};
const option = [
    /**
     * 查询
     */
    ["list", "/list", "get", true, "/ns/workstation"],
    /**
     * 添加
     */
    ["add", "/add", "post", true, "/ns/workstation"],
    /**
     * 修改
     */
    ["put", "/put", "put", true, "/ns/workstation"],
    /**
     * 取消
     */
    ["del", "/del", "delete", true, "/ns/workstation"],
]

create(option, Service, mock)

export default {
    Service,
    option
}
